import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer,
} from 'recharts';

/**
 * Spend-by-Category donut.
 * Extracted from Dashboard.js as part of the code-review refactor
 * (single-responsibility component, memoized to avoid rerenders when
 * sibling state - trends, savings, etc. - changes).
 */
function CategoryPieChartImpl({ data, colors, cs, delay = 0.6 }) {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay }}>
      <Card data-testid="category-distribution-chart">
        <CardHeader>
          <CardTitle>Spend by Category</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => {
                  const n = String(name);
                  return `${n.length > 14 ? `${n.slice(0, 14)}…` : n} ${(percent * 100).toFixed(0)}%`;
                }}
                outerRadius={85}
                fill="#8884d8"
                dataKey="value"
              >
                {data.map((_, i) => (
                  <Cell key={`cell-${i}`} fill={colors[i % colors.length]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: 'hsl(var(--popover))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '8px',
                }}
                formatter={(value) => [`${cs}${value.toLocaleString()}`, 'Spend']}
              />
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </motion.div>
  );
}

export const CategoryPieChart = React.memo(CategoryPieChartImpl);
